<script setup>

import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../portal-editable-fields/EditableTextField.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <div>
        <div class="flex inset-0 justify-center items-center font-medium bg-white bg-opacity-50 py-20">
            <div class="p-4 bg-white rounded opacity-75">
                <div class="flex justify-center items-center pb-4"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path d="M17.841 15.659l.176.177.178-.177a2.25 2.25 0 0 1 3.182 3.182l-3.36 3.359-3.358-3.359a2.25 2.25 0 0 1 3.182-3.182zM12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 7.75-7.996L12 14zm0-13c3.315 0 6 2.685 6 6a5.998 5.998 0 0 1-5.775 5.996L12 13c-3.315 0-6-2.685-6-6a5.998 5.998 0 0 1 5.775-5.996L12 1zm0 2C9.79 3 8 4.79 8 7s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"></path></svg></div>
                <editable-text-field
                    text-type="h2"
                    custom-classes="text-lg font-semibold mb-2 text-center"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_no_data_yet"
                />
                <editable-text-field
                    text-type="p"
                    custom-classes="text-sm tracking-wide opacity-60 text-center"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_features_ref_lives_here_notice"
                />
            </div>
        </div>

    </div>
</template>
